import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-shipment-packing-list',
  templateUrl: './shipment-packing-list.component.html',
  styleUrls: ['./shipment-packing-list.component.scss']
})
export class ShipmentPackingListComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
